// extracted by mini-css-extract-plugin
export default {"container":"WindowTrim_container__j8657","productListContainer":"WindowTrim_productListContainer__1+riU","productGrid":"WindowTrim_productGrid__ZiKcT"};